import React from 'react';
import { Empty, Theme } from '@routific/hive';
import EmptyRobotSearchImage from '../../../../images/emptyRobotSearch.svg';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const EmptyTitle = styled.div`
  ${Theme.Typography.BodyStrong.toCssString()}
  color: ${Theme.Colors.textSecondary};
`;

const EmptyDescription = styled.div`
  ${Theme.Typography.Caption.toCssString()}
  color: ${Theme.Colors.textSecondary};
`;

const EmptyImageContainer = styled.div`
  height: 290px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const EmptyImage = styled.img`
  max-height: 100%;
`;

const EmptyDriver: React.FC = () => {
  const { t } = useTranslation('components');

  return (
    <Empty
      style={{ width: '100%' }}
      size="small"
      image={(
        <EmptyImageContainer>
          <EmptyImage src={EmptyRobotSearchImage} alt="" />
        </EmptyImageContainer>
      )}
      title={<EmptyTitle>{t('assignDriver.empty.title')}</EmptyTitle>}
      description={<EmptyDescription>{t('assignDriver.empty.description')}</EmptyDescription>}
      data-cy="select-driver-empty"
    />
  );
};

export default EmptyDriver;
